import React, { useState, useEffect } from 'react';
import { Modal, StyleSheet, Pressable, SafeAreaView, View, TouchableOpacity, TouchableWithoutFeedback } from 'react-native';
import { BasicText as Text, Button } from '../Styles';
import styledComponentsNative from 'styled-components/native';
import styled from 'styled-components/native';
import WasteBrand from '../../WasteTheme';

//https://reactnative.dev/docs/modal

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.8)"
    },
    modalView: {
        margin: 20,
        backgroundColor: "white",
        borderRadius: 20,
        padding: 35,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    buttonOpen: {
        backgroundColor: "#F194FF",
    },
    buttonClose: {
        backgroundColor: "#2196F3",
        width: "100%",
        marginTop: 10
    },
    textStyle: {
        color: "white",
        fontWeight: "bold",
        textAlign: "center"
    },
    modalBody: {
        marginBottom: 10,
        zIndex: 1,
        maxWidth: 400
    }
});

const ModalButton = styled(Button)`
    width: 150px;
    text-align: center;
`;

const ModalContext = React.createContext({close: ()=>console.log("unset"), updateChildren: (children)=>console.log("unset")});

const CoreModal = ({ children, modalVisible, setModalVisible, customCloseText = "Close", extraModalStyles = {}}) => {
    const [childrenState, setChildrenState] = useState(null);

    useEffect(()=>{
        setChildrenState(children);
    }, [children]);

    const backgroundEvent = (e) =>{
        e.stopPropagation();
        setModalVisible(false);
    }

    const updateModalVisibility = (e) => {
        e.stopPropagation();
        setModalVisible(!modalVisible)
    }

    const updateChildren = (newChildren) => {
        setChildrenState(newChildren);
    }
    
    return <ModalContext.Provider value={{close: backgroundEvent, updateChildren: updateChildren}}>
        <Modal
            animationType="none"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => {
                setModalVisible(false);
            }}
        >
            <TouchableOpacity style={styles.centeredView} onPressOut={backgroundEvent} activeOpacity={1}>
                <TouchableOpacity style={[styles.modalView, extraModalStyles]} onPress={null} activeOpacity={1}>
                    <View style={styles.modalBody}>
                        {childrenState}
                    </View>
                    {customCloseText == null || customCloseText == ""? 
                        null :
                        <ModalButton onPress={updateModalVisibility} theme={WasteBrand}>
                            <Text style={styles.textStyle}>{customCloseText}</Text>
                        </ModalButton>
                    }
                </TouchableOpacity>
            </TouchableOpacity>
        </Modal>
    </ModalContext.Provider>;
}

export { ModalContext };
export default CoreModal;